const MENSAGEM_PADRAO = 'Não foi possível entrar. Verifique os dados e tente novamente.';

/**
 * Extrai a mensagem exibível de um erro retornado pelo endpoint de autenticação,
 * seguindo o mesmo contrato usado pelo card de login.
 */
export function mensagemDeErroLogin(erro: unknown): string {
  const resposta = (erro as { error?: { message?: string; errors?: unknown[] } })?.error;

  const errors = Array.isArray(resposta?.errors) ? resposta.errors.filter(Boolean).join(' ') : '';

  return resposta?.message || errors || MENSAGEM_PADRAO;
}
